import { TableCell as MUITableCell } from '@material-ui/core';
import { withStyles, Theme, createStyles } from '@material-ui/core/styles';

export const TableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: '#FBFCFE',
      color: '#64748B',
      fontSize: 12,
      fontWeight: 600,
      letterSpacing: '0.02em',
      borderBottom: '1px solid #EEF1F4',
    },
    body: {
      fontSize: 14,
    },
  })
)(MUITableCell);
